import { Component } from '@angular/core';

@Component({
  selector:"not-found",
  templateUrl: "404.component.html",
  styleUrls: ["404.component.css"]
})

export class NotFoundComponent {

}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/404/404.component.ts